import script from "./TableColumnsSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./TableColumnsSelect.vue?vue&type=script&setup=true&lang=js"

import "./TableColumnsSelect.vue?vue&type=style&index=0&id=1eb3cf91&scoped=true&lang=css"

import exportComponent from "D:\\projectLy\\2025伟本\\weben-les-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eb3cf91"]])

export default __exports__